/* eslint-disable array-callback-return */
/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import {
  Card,
  Col,
  Container,
  FormSelect,
  Modal,
  ModalFooter,
  Row,
} from "react-bootstrap";
import DatePicker from "react-multi-date-picker";
import InputIcon from "react-multi-date-picker/components/input_icon";
import { useNavigate, useParams } from "react-router-dom";
import { Button, DropDown, Input } from "../../components";
import { useAppDispatch, useAppSelector } from "../../redux/Hooks/Hook";
import { AllCoachesList } from "../../redux/Slice/Coaches/CoachesListSlice";
import {
  DeleteFromDatabase,
  GetSessionDetails,
  UpdateSession,
} from "../../utilities/api/session";
import { LableFromEnums } from "../../utilities";
import { toast } from "react-toastify";
import { images } from "../../config/images";
import {
  validatePositiveValue,
} from "../../utilities/utils";
import { countWeeks } from "./session.utils";
import { differenceInCalendarDays, format } from "date-fns";
import BootstrapSelect from "react-bootstrap-select-dropdown";
import { GetAvailableCourtForSession } from "../../utilities/api/courts";
import { TIME_OPTIONS } from "../../utilities/utils"
import { messages } from "../../utilities/Messages";

const errorInit = {
  maxNoOfAttendees: "",
  minWeeksToBook: "",
  courts: "",
  coachId: "",
  rule: [],
};

const WeekOptions = [
  { label: "1 Session per week", value: 1 },
  { label: "2 Sessions per week", value: 2 },
  { label: "3 Sessions per week", value: 3 },
  { label: "4 Sessions per week", value: 4 },
  { label: "5 Sessions per week", value: 5 },
  { label: "6 Sessions per week", value: 6 },
  { label: "All Sessions per week", value: 7 },
];

const EditSession = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  const { AllCoachesData, errorMessage } = useAppSelector((state) => state.coachList);
  const { Enums } = useAppSelector((state) => state.enumsArray);

  const [session, setSession] = useState<any>({});
  const [error, setError] = useState({ ...errorInit });
  const [maxNumberOfWeeks, setMaxNumberOfWeeks] = useState<any>(null);
  const [deleteDialogData, setDeleteDialogData] = useState({
    show: false,
    type: "",
    typeId: "",
  });

  const [offers, setOffers] = useState({
    discountPercent: "",
    noOfWeeks: "",
  });
  const [courtList, setCourtList] = useState<any>([]);
  const [submitButton, setSubmitButton] = useState(false);
  const [selectedCourtList, setSelectCourtList] = useState<any>([]);
  const getMessage = messages.coaching;

  if (errorMessage) {
    toast.error(errorMessage.message)
  }
  const GetData = () => {
    GetSessionDetails(id)
      .then((response) => {
        const sessionData = response?.data || {};
        setSelectCourtList(sessionData?.sessionCourts);

        setSession({
          ...sessionData,
          coachId: sessionData?.coach?.id,
          courts:
            sessionData?.sessionCourts?.map?.(
              (_data: any) => _data?.court?.id
            ) || [],
          sportId: sessionData?.sport?.id,
          rules:
            sessionData?.sessionRules?.map?.((_data: any) => ({

              description: _data?.rule.description,
              subject: _data?.rule.subject,
              ruleId: _data?.ruleId,
            })) || [],
          rates:
            sessionData?.sessionRates?.map?.((_data: any) => ({

              ratePerSession: _data?.ratePerSession,
              noOfDays: _data?.noOfDays,
              rateId: _data?.id,
            })) || [],
          offers:
            sessionData?.sessionOffers?.map?.((_data: any) => ({
              ...(_data || {}),
              offerId: _data?.id,
            })) || [],
        });
      })
      .catch((error) => toast.error(error?.message));
  };

  useEffect(() => {
    dispatch(AllCoachesList());
    GetData();
  }, []);

  const GetCourt = async () => {
    const payload = {
      facilityId: Number(session.facility?.id),
      sportId: session?.sportId,
      startDate: session.startDate
        ? format(getFormatedDate(session.startDate), "yyyy-MM-dd")
        : session.startDate,
      endDate: session.endDate
        ? format(getFormatedDate(session.endDate), "yyyy-MM-dd")
        : session.endDate,
      slots: session.sessionSlots?.map((item: any) => ({
        sessionDay: item.sessionDay,
        endTime: item.endTime,
        startTime: item.startTime,
      })),

      sessionId: session.id,
    };

    if (session.sessionSlots?.length && session.startDate) {
      const result = await GetAvailableCourtForSession(payload);
      if (result.status === 200) {
        setCourtList(result.data.data.rows);
      } else {
        toast.error(result.response.data.message);
      }
    }
  };

  useEffect(() => {
    GetCourt();
  }, [session.startDate, session.endDate, session?.sessionSlots]);

  useEffect(() => {
    if (session?.startDate && session?.endDate) {
      const _maxNumberOfWeeks = countWeeks(
        getFormatedDate(session?.startDate),
        getFormatedDate(session?.endDate)
      );

      setMaxNumberOfWeeks(_maxNumberOfWeeks);
    }
  }, [session]);

  const handleDeleteFromDatabase = (type: string, typeId: string) => {
    DeleteFromDatabase(type, `${id}`, typeId)
      .then(() => {
        GetData();
        handleClose();
      })
      .catch((error) => toast.error(error?.message));
  };

  const handleClose = () => {
    setDeleteDialogData({
      show: false,
      type: "",
      typeId: "",
    });
  };

  const handleDeleteRate = (_index: number) => {
    let { rates } = session;
    const rate = rates?.find?.((_rate: any, _idx: any) => _idx === _index);
    if (rate?.rateId) {
      setDeleteDialogData({
        show: true,
        type: "rate",
        typeId: rate?.rateId,
      });
    } else {
      rates = rates?.filter?.((_rate: any, _idx: any) => _idx !== _index);
      updateSessionValue("rates", rates);
    }
  };

  const handleAddOffer = () => {
    if (offers?.discountPercent && offers?.noOfWeeks) {
      let { offers: updateOffer } = session;
      const hasNumberOfWeeks = updateOffer?.find?.(
        (_offer: any) => Number(_offer?.noOfWeeks) === Number(offers?.noOfWeeks)
      );
      if (hasNumberOfWeeks) {
        updateOffer = updateOffer?.map?.((_offer: any) => {
          if (Number(_offer?.noOfWeeks) === Number(offers?.noOfWeeks)) {
            return {
              ..._offer,
              discountPercent: Number(offers?.discountPercent),
            };
          }
          return _offer;
        });
      } else {
        updateOffer = [
          ...updateOffer,
          {
            discountPercent: Number(offers.discountPercent),
            noOfWeeks: Number(offers.noOfWeeks),
          },
        ];
      }
      updateSessionValue("offers", updateOffer);
      setOffers({
        discountPercent: "",
        noOfWeeks: "",
      });
    }
  };

  const handleDeleteOffer = (_index: number) => {
    let { offers: offe } = session;

    const offer = offe?.find?.((_rate: any, _idx: any) => _idx === _index);
    if (offer?.offerId) {
      setDeleteDialogData({
        show: true,
        type: "offer",
        typeId: offer?.offerId,
      });
    } else {
      offe = offe?.filter?.((_rate: any, _idx: any) => _idx !== _index);
      updateSessionValue("offers", offe);
    }
  };

  const updateSessionValue = (key: string, value: any) => {
    setError({ ...errorInit });
    setSession((_oldSession: any) => ({ ..._oldSession, [key]: value }));
  };

  const updateSessionSlot = (id: string, key: string, value: string) => {
    const _sessionSlots = session?.sessionSlots?.map?.((_slot: any) => {
      if (_slot?.id === id) {
        _slot[key] = value;
      }
      return _slot;
    });
    updateSessionValue("sessionSlots", _sessionSlots);
  };

  const isValidSession = () => {
    let _isValid = true;

    _isValid = !!(
      session?.courts &&
      session?.coachId &&
      session?.maxNoOfAttendees &&
      session?.maxNoOfAttendees <= 99999 &&
      session?.minWeeksToBook
    );

    if (_isValid) {
      session?.rules?.forEach?.((_rule: any) => {
        if (!_rule?.subject) {
          _isValid = false;
        }
        if (_rule?.subject.length > 200) {
          _isValid = false;
        }
      });
    }

    return _isValid;
  };

  const handleAddRule = () => {
    let { rules } = session;
    rules = [
      ...rules,
      {
        subject: "",
        description: "",
      },
    ];
    updateSessionValue("rules", rules);
  };

  const handleRuleChange = (_index: number, value: string) => {
    let { rules } = session;
    rules[_index].subject = value;
    updateSessionValue("rules", rules);
  };

  const handleDeleteRule = (_index: number) => {
    let { rules } = session;
    const rule = rules?.find?.((_rate: any, _idx: any) => _idx === _index);
    if (rule?.ruleId) {
      setDeleteDialogData({
        show: true,
        type: "rule",
        typeId: rule?.ruleId,
      });
    } else {
      rules = rules?.filter?.((_rule: any, _idx: any) => _idx !== _index);
      updateSessionValue("rules", rules);
    }
  };

  const handleRateChange = (_index: number, value: string) => {
    if (validatePositiveValue(value) || !value) {
      let { rates } = session;
      rates[_index].ratePerSession = value;
      updateSessionValue("rates", rates);
    }
  };

  const handleSubmit = async () => {
    setSubmitButton(true);
    let offersWithoutId: any = session?.offers?.map(function (item: any) {
      delete item.id;
      return item;
    });

    if (isValidSession()) {
      const payload = {
        coachId: session?.coachId,
        startDate: session.startDate
          ? format(getFormatedDate(session.startDate), "yyyy-MM-dd")
          : session.startDate,
        endDate: session.endDate
          ? format(getFormatedDate(session.endDate), "yyyy-MM-dd")
          : session.endDate,
        minWeeksToBook: Number(session?.minWeeksToBook),
        maxNoOfAttendees: Number(session?.maxNoOfAttendees),
        courts: session?.courts,
        rates: session?.rates?.map((rate: any) => ({
          ...rate,
          ratePerSession: Number(rate.ratePerSession),
        })) || [],
        slots: session.sessionSlots?.map((item: any) => ({
          sessionDay: item.sessionDay,
          endTime: item.endTime,
          startTime: item.startTime,
          slotId: item.id,
        })),
        offers: offersWithoutId || [],
        rules: session?.rules || [],
      };

      const result = await UpdateSession(session?.id, payload);
      if (result.status === 200) {
        navigate("/coaching");
      }
      if (result?.response?.data?.message) {
        toast.error(result.response.data.message);
      }
      if (result?.data?.message) {
        toast.success(result.data.message);
      }
    } else {
      let message: any = [];
      session?.rules?.map((_rule: any, index: any) => {
        if (!_rule?.subject) {
          message[index] = getMessage.subject_isNotEmpty;
        }
        if (_rule?.subject.length > 200) {
          message[index] =
            getMessage.subject_length;
        }
      });
      const _error = {
        maxNoOfAttendees: session?.maxNoOfAttendees
          ? session?.maxNoOfAttendees.length > 5
            ? getMessage.session_maximumAttendees
            : ""
          : getMessage.session_isNotEmpty,
        minWeeksToBook: session?.minWeeksToBook
          ? ""
          : getMessage.minimum_weeks,
        courts: session?.courts?.length ? "" : getMessage.court_required,
        coachId: session?.coachId ? "" : getMessage.court_coachName,
        rule: message,
        rates: session?.rates?.length ? "" : getMessage.court_charges,
      };
      setError({ ..._error });
    }
    setSubmitButton(false);
  };

  const taxSession = session?.sessionTaxes?.reduce(
    (_result: any, _tax: any) => {
      _result[_tax?.tax?.type] = _tax?.percentage;
      return _result;
    },
    {}
  );

  const getFormatedDate = (_date: string) => {
    if (!_date) {
      return new Date();
    }
    if (_date?.includes?.("GMT")) {
      return new Date(_date);
    }
    const [_dd, _mm, _yy] = _date?.split?.("/") || [];
    return new Date(`${_mm}/${_dd}/${_yy}`);
  };

  const setPositiveValue = (key = "", value = "", type: string = "float") => {
    if (validatePositiveValue(value, type)) {
      updateSessionValue(key, value);
    }
  };

  const options = courtList?.map((item: any) => {
    return {
      labelKey: item.id,
      value: `${item.name}`,
    };
  });

  const handleChange = (value: any) => {
    updateSessionValue("courts", value.selectedKey);
  };

  return (
    <>
      <Container fluid className="g-0">
        <Card>
          <Card.Body>
            <div className="page-title align-items-center d-flex justify-content-between">
              <Card.Title className="mb-0">Edit Session</Card.Title>
            </div>
            <hr />
            <Col lg={12}>
              <div className="reschedule-details">
                <Row className="text-start row-mb">
                  <Col lg={3}>
                    <span className="user-info-title text-info text-uppercase d-block mb-2">
                      Session Name
                    </span>
                    <span className="user-info">{session?.name}</span>
                  </Col>
                  <Col lg={2}>
                    <span className="user-info-title text-info text-uppercase d-block mb-2">
                      Total Session
                    </span>
                    <span className="user-info">
                      {session?.totalNoOfSessions}
                    </span>
                  </Col>
                  <Col lg={2}>
                    <span className="user-info-title text-info text-uppercase d-block mb-2">
                      Session Statuss
                    </span>
                    <span className="user-info">
                      {LableFromEnums(session?.status, Enums)}
                    </span>
                  </Col>
                  <Col lg={2}>
                    <span className="user-info-title text-info text-uppercase d-block mb-2">
                      Completed Session
                    </span>
                    <span className="user-info">
                      {session?.completedSessions}
                    </span>
                  </Col>
                  <Col lg={2}>
                    <span className="user-info-title text-info text-uppercase d-block mb-2">
                      Sport Name
                    </span>
                    <span className="user-info">{session?.sport?.name}</span>
                  </Col>
                </Row>
                <Row className="text-start row-mb">
                  <Col lg={3}>
                    <span className="user-info-title text-info text-uppercase d-block mb-2">
                      Court
                    </span>
                    <span className="user-info">
                      {selectedCourtList.map((item: any, index: number) => {
                        return index == 0
                          ? item?.court?.name
                          : ", " + item?.court?.name;
                      })}
                    </span>
                  </Col>
                  <Col lg={2}>
                    <span className="user-info-title text-info text-uppercase d-block mb-2">
                      Current Attendees
                    </span>
                    <span className="user-info">
                      {session?.currentAttendees}
                    </span>
                  </Col>
                  <Col lg={2}>
                    <span className="user-info-title text-info text-uppercase d-block mb-2">
                      I-GST (%)
                    </span>
                    <span className="user-info">{taxSession?.IGST}</span>
                  </Col>
                  <Col lg={2}>
                    <span className="user-info-title text-info text-uppercase d-block mb-2">
                      C-GST (%)
                    </span>
                    <span className="user-info">{taxSession?.CGST}</span>
                  </Col>
                  <Col lg={2}>
                    <span className="user-info-title text-info text-uppercase d-block mb-2">
                      S-GST (%)
                    </span>
                    <span className="user-info">{taxSession?.SGST}</span>
                  </Col>
                </Row>
                <Row className="text-start row-mb"></Row>
              </div>
            </Col>
            <hr />
            <Row className="align-items-end mb-3"></Row>
            <Row className="row-mb">
              <Col lg={12}>
                <div className="text-start">
                  <label htmlFor="addedcharges" className="form-label">
                    Added Charges
                  </label>

                  <Row>
                    {session?.rates
                      ?.sort((a: any, b: any) => a?.noOfDays - b?.noOfDays)
                      ?.map?.((_rate: any, _index: any) => {
                        const label = WeekOptions?.find?.(
                          (_opt) => _opt?.value === _rate?.noOfDays
                        )?.label;
                        return (
                          <Col lg={6} key={_rate?.noOfDays}>
                            <Card className="bg-light bg-opacity-25 border-left-5 border-light mb-3">
                              <Card.Body className="align-items-center card-body d-flex justify-content-between p-2">
                                <div className="date-range fw-semibold d-flex align-items-center">
                                  {label} -{" "}
                                  <span className="rupees-symbol ms-1">&#8377;</span>
                                  <Input
                                    type="text"
                                    name="ratePerSession"
                                    id={`ratePerSession_${_index}`}
                                    className="form-control ms-2 me-2"
                                    style={{ width: "100px", display: "inline-block" }}
                                    value={_rate?.ratePerSession || ""}
                                    onChange={(e: any) => handleRateChange(_index, e?.target?.value)}
                                  />
                                  per session{" "}
                                </div>
                                {session?.rates?.length === _index + 1 ||
                                  (session?.rates?.length != 1 && (
                                    <Button
                                      type="button"
                                      bname="Delete"
                                      name="deletecharges"
                                      id="deletecharges"
                                      className="btn btn-sm btn-outline-danger rounded-1"
                                      onClick={() => handleDeleteRate(_index)}
                                    ></Button>
                                  ))}
                              </Card.Body>
                            </Card>
                          </Col>
                        );
                      })}
                  </Row>
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={6}>
                <div className="mb-3 text-start">
                  <label htmlFor="startdate" className="form-label">
                    Start Date <small className="text-danger">*</small>
                  </label>
                  <DatePicker
                    id="startdate"
                    inputClass="form-control"
                    readOnly={true}
                    containerStyle={{
                      pointerEvents: "none",
                    }}
                    format="DD/MM/YYYY"
                    containerClassName="custom-container"
                    value={getFormatedDate(session?.startDate) || ""}
                    disabled={true}
                    render={
                      <InputIcon className="form-control bg-light bg-opacity-25" />
                    }
                  />
                </div>
              </Col>
              <Col lg={6}>
                <div className="mb-3 text-start">
                  <label htmlFor="enddate" className="form-label">
                    End Date
                  </label>
                  <DatePicker
                    id="enddate"
                    inputClass="form-control"
                    format="DD/MM/YYYY"
                    containerClassName="custom-container"
                    editable={false}
                    onChange={(date: any) => {
                      updateSessionValue(
                        "endDate",
                        date?.toDate().toUTCString()
                      );
                    }}
                    value={
                      session?.endDate ? getFormatedDate(session?.endDate) : ""
                    }
                    render={<InputIcon className="form-control" />}
                    minDate={
                      differenceInCalendarDays(
                        getFormatedDate(session?.startDate),
                        new Date()
                      ) > 0
                        ? getFormatedDate(session?.startDate)
                        : new Date()
                    }
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={12}>
                <div className="text-start">
                  <label htmlFor="selectendtime" className="form-label">
                    Selected Slots
                  </label>
                  <Row>
                    {session?.sessionSlots?.map?.((_slot: any) => (
                      <Col lg={6} key={_slot?.id}>
                        <Card className="bg-light bg-opacity-25 border-left-5 border-light mb-3">
                          <Card.Body className="align-items-center d-flex justify-content-start p-2">
                            <div className="date-range fw-semibold me-3">
                              {_slot?.sessionDay} -{" "}
                            </div>
                            <div className="align-items-center d-flex fw-semibold time-slot">
                              {" "}
                              <div className="me-3 text-start   ">
                                <FormSelect
                                  className="form-control"
                                  id="startTime"
                                  name="startTime"
                                  value={
                                    _slot?.startTime?.length > 5
                                      ? `${_slot?.startTime?.split(":")[0]}:${_slot?.startTime?.split(":")[1]
                                      }`
                                      : _slot?.startTime
                                  }
                                  onChange={(e) =>
                                    updateSessionSlot(
                                      _slot?.id,
                                      "startTime",
                                      e?.target?.value
                                    )
                                  }
                                >
                                  <option value="">Select</option>
                                  {TIME_OPTIONS.map((item: any) => {
                                    return (
                                      <option
                                        value={item}
                                        key={"startTime" + item}
                                      >
                                        {item}
                                      </option>
                                    );
                                  })}
                                </FormSelect>
                              </div>{" "}
                              TO
                              <div className="ms-3 text-start">
                                <FormSelect
                                  className="form-control"
                                  id="endTime"
                                  name="endTime"
                                  value={
                                    _slot?.endTime?.length > 5
                                      ? `${_slot?.endTime?.split(":")[0]}:${_slot?.endTime?.split(":")[1]
                                      }`
                                      : _slot?.endTime
                                  }
                                  onChange={(e) =>
                                    updateSessionSlot(
                                      _slot?.id,
                                      "endTime",
                                      e?.target?.value
                                    )
                                  }
                                >
                                  <option value="">Select</option>
                                  {TIME_OPTIONS.map((item: any) => {
                                    if (item > _slot?.startTime) {
                                      return (
                                        <option
                                          value={item}
                                          key={"endTime" + item}
                                        >
                                          {item}
                                        </option>
                                      );
                                    }
                                  })}
                                </FormSelect>
                              </div>
                            </div>
                          </Card.Body>
                        </Card>
                      </Col>
                    ))}
                  </Row>
                </div>
              </Col>
              <hr />
            </Row>
            <Row className="align-items-end mb-3">
              <Col lg={3}>
                <div className="text-start">
                  <label htmlFor="add-discount" className="form-label">
                    Add Discount (%)
                  </label>
                  <Input
                    type="text"
                    name="add-discount"
                    id="add-discount"
                    className="form-control"
                    value={offers?.discountPercent || ""}
                    onChange={(e: any) => {
                      if (
                        (validatePositiveValue(e.target.value) &&
                          Number(e.target.value) <= 100 &&
                          Number(e.target.value) >= 1) ||
                        !e.target.value
                      ) {
                        setOffers((_oldValue: any) => ({
                          ..._oldValue,
                          discountPercent: e.target.value,
                        }));
                      }
                    }}
                  />
                </div>
              </Col>
              <Col lg={3}>
                <div className="text-start">
                  <label htmlFor="weeks" className="form-label">
                    Add Booking of Weeks
                  </label>
                  <div
                    style={{ display: "flex", gap: 5, alignItems: "center" }}
                  >
                    <Input
                      type="text"
                      name="add-discount"
                      id="add-discount"
                      className="form-control"
                      value={offers?.noOfWeeks || ""}
                      onChange={(e: any) => {
                        if (maxNumberOfWeeks == null) {
                          toast.error(`Please select start date and end date.`);
                        } else {
                          if (
                            maxNumberOfWeeks &&
                            e.target.value > maxNumberOfWeeks
                          ) {
                            toast.error(
                              `As per selected slots, offer for weeks can not be greater than ${maxNumberOfWeeks}`
                            );
                          } else {
                            if (validatePositiveValue(e.target.value)) {
                              setOffers((_oldValue: any) => ({
                                ..._oldValue,
                                noOfWeeks: e.target.value,
                              }));
                            }
                          }
                        }
                      }}
                    />
                  </div>
                </div>
              </Col>
              <Col lg={2} className="text-start">
                <Button
                  type="button"
                  bname="Add"
                  name="add-discountbtn"
                  id="add-discountbtn"
                  className="btn btn-primary rounded-1 me-3"
                  onClick={handleAddOffer}
                ></Button>
              </Col>
            </Row>
            <Row>
              <Col lg={12}>
                <div className="text-start">
                  <label htmlFor="added-discount" className="form-label">
                    Added Discount
                  </label>
                  <Row>
                    {session?.offers?.map?.((_offer: any, _index: any) => (
                      <Col lg={6} key={_offer?.noOfWeeks}>
                        <Card className="bg-opacity-25 bg-opacity-50 bg-success border-left-5 border-success card mb-3">
                          <Card.Body className="align-items-center card-body d-flex justify-content-between p-2">
                            <div className="date-range fw-semibold">
                              {_offer?.discountPercent}% Discount added for{" "}
                              {_offer?.noOfWeeks} weeks
                            </div>
                            <Button
                              type="button"
                              bname="Delete"
                              name="deletediscount"
                              id="deletediscount"
                              className="btn btn-danger btn-sm rounded-1"
                              onClick={() => handleDeleteOffer(_index)}
                            ></Button>
                          </Card.Body>
                        </Card>
                      </Col>
                    ))}
                  </Row>
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={6}>
                <div className="mb-3 text-start">
                  <label htmlFor="minimumsessionattend" className="form-label">
                    Minimum number of Weeks to book
                  </label>
                  <Input
                    onChange={(e: any) => {
                      if (maxNumberOfWeeks == null) {
                        toast.error(getMessage.startDate_endDate_isNotEmpty);
                      } else {
                        if (
                          maxNumberOfWeeks &&
                          e.target.value > maxNumberOfWeeks
                        ) {

                          toast.error(
                            `As per selected slots, minimum number of weeks can not be greater than ${maxNumberOfWeeks}`
                          );
                        } else {
                          setPositiveValue("minWeeksToBook", e?.target?.value);
                        }
                      }
                    }}
                    value={session?.minWeeksToBook || ""}
                    type="text"
                    name="minimumweekstobook"
                    id="minimumweekstobook"
                    className="form-control"
                  />
                  {error?.minWeeksToBook && (
                    <div className="error-msg">{error?.minWeeksToBook}</div>
                  )}
                </div>
              </Col>
              <Col lg={6}>
                <div className="mb-3 text-start">
                  <label htmlFor="maximumattendees" className="form-label">
                    Maximum number of Attendees
                  </label>
                  <Input
                    onChange={(e: any) =>
                      setPositiveValue(
                        "maxNoOfAttendees",
                        e?.target?.value,
                        "int"
                      )
                    }
                    value={session?.maxNoOfAttendees || ""}
                    type="text"
                    name="maximumattendees"
                    id="maximumattendees"
                    className="form-control"
                  />
                  {error?.maxNoOfAttendees && (
                    <div className="custom-error-msg">
                      ({error?.maxNoOfAttendees})
                    </div>
                  )}
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={6}>
                <div className="mb-3 text-start">
                  <label htmlFor="coachname" className="form-label">
                    Select Coach Name
                  </label>
                  {error?.coachId && (
                    <div className="custom-error-msg">({error?.coachId})</div>
                  )}
                  <DropDown
                    className="form-control"
                    id="coachId"
                    name="coachId"
                    onChange={(e: any) =>
                      updateSessionValue("coachId", Number(e?.target?.value))
                    }
                    value={session?.coachId || ""}
                  >
                    <option>Select Coach</option>
                    {AllCoachesData?.map?.((_coach) => (
                      <option key={_coach?.id} value={_coach?.id}>
                        {_coach?.fullName}
                      </option>
                    ))}
                  </DropDown>
                </div>
              </Col>
              <Col lg={6}>
                <div className="mb-3 text-start">
                  <label htmlFor="assigncourt" className="form-label">
                    Assign Court
                  </label>
                  {error?.courts && (
                    <div className="custom-error-msg">({error?.courts})</div>
                  )}
                  <BootstrapSelect
                    className="form-select-custom form-control"
                    selectStyle=""
                    actionBtnStyle="btn-outline-primary"
                    options={options}
                    isMultiSelect={true}
                    showTick={true}
                    defaultOptions={session?.sessionCourts?.map(
                      (item: any) => item?.court?.id
                    )}

                    showAction={true}
                    placeholder="Select Facility For User"
                    onChange={handleChange}
                  />
                </div>
              </Col>
            </Row>
            <hr />
            <div className="custom-label-layout">
              <label htmlFor="selectendtime" className="form-label">
                Rules
                <small className="text-danger">*</small>
              </label>
            </div>
            {session?.rules?.map?.((_rule: any, _index: any) => (
              <div
                className="border rounded-1 sports-field "
                key={`Rule_${_index}`}
                style={{ marginTop: 0, marginBottom: "1.875rem" }}
              >
                <Row className="align-items-center g-0">
                  <Col lg={2}>
                    <h4>Rule {Number(_index) + 1}</h4>
                  </Col>
                  <Col lg={10}>
                    <div className="sports-detail">
                      <div className="mb-3 text-start">
                        <label htmlFor="subjectrule" className="form-label">
                          Subject of Rule{" "}
                          <small className="text-danger">*</small>
                        </label>
                        <Input
                          type="text"
                          placeholder="Enter Subject of Rule"
                          id="subjectrule"
                          name="subjectrule"
                          className="form-control"
                          onChange={(e: any) =>
                            handleRuleChange(_index, e?.target?.value)
                          }
                          value={_rule?.subject || ""}
                        />
                        {error?.rule && (
                          <div className="error-msg">{error?.rule[_index]}</div>
                        )}
                      </div>
                    </div>
                  </Col>
                </Row>
                {_index !== 0 && (
                  <img
                    src={images.deletesport.default}
                    className="delete-sport"
                    alt="Delete Sport"
                    onClick={handleDeleteRule.bind(this, _index)}
                  />
                )}
              </div>
            ))}
            <Row>
              <Col lg={12} className="text-end">
                <Button
                  type="button"
                  bname={session?.rules?.length ? "Add Rule" : "Add Rules"}
                  name="addmore"
                  id="addmore"
                  className="btn btn-primary rounded-1"
                  onClick={handleAddRule}
                ></Button>
              </Col>
            </Row>
            <hr />
            <Row className="text-end">
              <Col lg={12}>
                <Button
                  disabled={submitButton}
                  type="button"
                  bname={submitButton ? "Confirming" : "Confirm"}
                  name="confirm"
                  id="confirm"
                  className="btn btn-primary rounded-1"
                  onClick={() => handleSubmit()}
                ></Button>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Container>
      <Modal show={deleteDialogData?.show} onHide={handleClose} centered>
        <Modal.Header className="border-0 pb-0 pb-2" closeButton>
          <Modal.Title id="contained-modal-title-vcenter fw-semibold">
            {`Delete ${deleteDialogData?.type}`}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to delete?</p>
          <p>After delete, it will be removed from database too!</p>
          <ModalFooter className="justify-center">
            <div className="">
              <Button
                onClick={() =>
                  handleDeleteFromDatabase(
                    deleteDialogData?.type,
                    deleteDialogData?.typeId
                  )
                }
                type="button"
                bname="Delete"
                name="paid"
                id="paid"
                className="btn btn-primary rounded-1 mt-1 me-3"
              ></Button>
              <Button
                onClick={handleClose}
                type="button"
                bname="Cancel"
                name="cancel"
                id="cancel"
                className="btn btn-light rounded-1 mt-1"
              ></Button>
            </div>
          </ModalFooter>
        </Modal.Body>
      </Modal>
    </>
  );
};
export { EditSession };
